<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>{{ `แบบฟอร์ม${form_title}แบบฟอร์ม` }}</v-card-title>      
      <v-card-text class="pt-0">
        <v-text-field v-model="form.name" outlined dense label="ชื่อแบบฟอร์ม"></v-text-field>
        <v-select v-model="form.form_group_id" outlined dense :items="form_groups" item-text="name_th" item-value="id" label="ประเภทแบบฟอร์ม"></v-select>
        <v-file-input v-model="form.files" class="mt-5" dense outlined multiple :label="form_type === 'EDIT' ? 'แนบไฟล์ใหม่' : 'แนบไฟล์'"></v-file-input>

      </v-card-text>
      <v-card-actions class="d-flex flex-row justify-center">
        <v-btn color="success" @click="submit">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    form: {
      form_group_id: '',
      name: '',
      files: []
    }
  }),
  computed: {
    form_type() { return this.$route.meta.form_type },
    form_title() { return this.$route.meta.form_title },
    form_groups() { return this.$store.state.form.form_groups },
  },
  mounted() {
    if(this.form_type === 'EDIT') {
      this.$store.dispatch('form/edit', this.$route.params.id)
        .then(resp => {
          this.form = {
            id: resp.id,
            form_group_id: resp.form_group_id,
            name: resp.name
          }
        });
    }
  },
  methods: {
    submit() {
      this.$store.dispatch(`${this.form_type === 'CREATE' ? 'form/store' : 'form/update'}`, this.createFormData(this.form)).then(() => {
        this.$router.push({ name: 'FormList' });
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'บันทึกข้อมูลสำเร็จ'
        });
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    },
		createFormData(form) {
      let formData = new FormData;
      
      if(form.id) {
        formData.append('id', form.id);
      }

      formData.append('form_group_id', form.form_group_id);
      formData.append('name', form.name);
      
      if(form.files) {
        form.files.forEach(item => {
          formData.append('files[]', item);
        });
      }
      
			return formData;
    }
  }
}
</script>

<style lang="scss">
  .cover-zone {
    border: 2px dashed;
    cursor: pointer;
  }
  .img-fluid {
    width: 100%;
  }
</style>